import { ReactComponent as LogoSpap } from '../../../Assets/Images/Backoffice/Login/SPAP-Sociedade-Portuguesa-de-Anatomia-Patologica.svg';
import { Button, Modal, Input, notification } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import React, { useRef, useEffect, useState } from "react";
import EmailEditor from "react-email-editor";
import axios from "axios";
import { ArrowLeftOutlined, SaveOutlined } from "@ant-design/icons";

export default function UnlayerEditor() {
  const emailEditorRef = useRef(null);
  const { id } = useParams();
  const navigate = useNavigate();

  const [showNameModal, setShowNameModal] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [pendingContent, setPendingContent] = useState(null);

  const token = JSON.parse(localStorage.getItem("session_data"))?.token;

  const defaultDesign = {
    body: {
      rows: [],
      values: {
        backgroundColor: "#FFFFFF",
        contentWidth: "800px",
        fontFamily: {
          label: "Roboto",
          value: "sans-serif"
        },
        padding: "0px",
        paddingLeft: "0px",     
        paddingRight: "0px"   
      }
    }
  };
  useEffect(() => {
    if (!id) return;
    axios
      .get(`https://api.spap.pt/api/admin/editor/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then((res) => {
        let content = res.data.content;

        if (typeof content === "string") {
          content = JSON.parse(content);
        }

        // 👇 FORÇAR WIDTH
        if (content?.design?.body?.values) {
          content.design.body.values.contentWidth = "800px";
          content.design.body.values.paddingLeft = "0px";
          content.design.body.values.paddingRight = "0px";
        }

        if (content?.design) {
          emailEditorRef.current.editor.loadDesign(content.design);
        }

        if (res.data.name) setTemplateName(res.data.name);
      })
      .catch(() => notification.error({ description: "Erro ao carregar o template." }));
  }, [id]);

  const onLoad = () => {
    if (!id) {
      emailEditorRef.current.editor.loadDesign(defaultDesign);
    }
  };

  const exportHtml = () => {
    if (!emailEditorRef.current?.editor) return;

    emailEditorRef.current.editor.exportHtml(({ design, html }) => {
      if (id) {
        saveTemplate(id, design, html); 
      } else {
        setPendingContent({ design, html }); 
        setShowNameModal(true);
      }
    });
  };

  const saveTemplate = (templateId, design, html, name) => {
    const data = { content: { design, html } };
    if (name) data.name = name;

    const method = templateId ? "put" : "post";
    const url = templateId
      ? `https://api.spap.pt/api/admin/editor/${templateId}`
      : "https://api.spap.pt/api/admin/editor";

    axios({
      method,
      url,
      data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(() => {
        notification.success({ description: "Template guardado com sucesso!" });
        navigate("/dashboard/editor");
      })
      .catch(() =>
        notification.error({ description: "Erro ao guardar o template!" })
      );
  };

  // Confirmar nome para novo template
  const handleConfirmName = () => {
    if (!templateName.trim()) {
      notification.error({ description: "Por favor insira um nome para o template." });
      return;
    }
    if (pendingContent) {
      saveTemplate(null, pendingContent.design, pendingContent.html, templateName.trim());
    }
    setShowNameModal(false);
    setTemplateName("");
    setPendingContent(null);
  };

  const handleCancelName = () => {
    setShowNameModal(false);
    setTemplateName("");
    setPendingContent(null);
  };

  const handleBack = () => navigate("/dashboard/editor");

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", background: "#fff" }}>
      <div
        style={{
          padding: "10px 15px",
          borderBottom: "1px solid #eee",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <LogoSpap style={{ height: "40px", width: "200px", display: "block" }} />

        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Button
            onClick={handleBack}
            icon={<ArrowLeftOutlined />}
            style={{ borderRadius: "4px" }}
          >
            Voltar
          </Button>

          <Button
            onClick={exportHtml}
            type="primary"
            icon={<SaveOutlined />}
            style={{ background: "#494D7D", borderRadius: "4px" }}
          >
            Guardar conteúdo
          </Button>
        </div>
</div>
      {/* Editor */}
      <div style={{ flex: 1, height: "85vh" }} id="editor-content">
        <EmailEditor
          ref={emailEditorRef}
          onLoad={onLoad}
          style={{ height: "91vh", width: "100%" }}
          options={{
            features: { responsive: true },
            appearance: { theme: "light" },
            tools: {
              paragraph: {
                properties: {
                  fontSize: {
                    value: "16px"
                  },

                }
              }
            }
          }}
        />
      </div>

      <Modal
        title="Nome do Template"
        open={showNameModal}
        onOk={handleConfirmName}
        onCancel={handleCancelName}
        okText="Confirmar"
        cancelText="Cancelar"
      >
        <Input
          placeholder="Insira o nome do template"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
        />
      </Modal>
    </div>
  );
}